import React from "react";
import { connect } from "react-redux";
import { DragDropContext } from "react-beautiful-dnd";
import TitleComponent from "../../components/TitleComponent";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import Trip from "../../components/Trip";
import ModalInfo from "../../containers/ModalInfo";
import config from "../../config";
import api from "../../api";
import { loadSchedule } from "../../actions/schedule";
import { setProductKey } from "../../actions/session";
import Select from "react-select";
import { Droppable } from "react-beautiful-dnd";
import { getWeek } from "../../lib/helper";
import LeftArrow from "../../assets/icons/arrow_left.svg";
import RightArrow from "../../assets/icons/arrow_right.svg";
import { notify } from "react-notify-toast";
import Loader from "../../components/LoaderComponent";
import { Checkbox } from "primereact/checkbox";
import ScheduleCopyHelper from "../../lib/ScheduleCopyHelper";
import { formatConflictMessage } from "../../lib/formatHelper";

import WarningDialog from "../../components/WarningDialog";
import SchedulerButtons from "../../components/SchedulerComponents/SchedulerButtons/SchedulerButtons";
import NoDirections from "../../components/SchedulerComponents/NoDirections";
import SchedulerHeader from "../../components/SchedulerComponents/SchedulerHeader";
import SchedulerRows from "../../components/SchedulerComponents/SchedulerRows";
import withTranslation from "../../i18n/withTranslation";

const dateFormat = config.get("dateFormat");

class TasksScheduler extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         currentDate: moment(),
         animatorName: "",
         optionalTrips: {},
         users: [],
         selectedProductKey: "",
         week: [],
         modalVisibility: false,
         deletedTaskId: null,
         modalContent: "",
         productKeys: [],
         isFetching: true,
         newTaskDate: null,
         isRequesting: false,
         copyScheduleMode: false,
         warningVisible: false,
         warningConflicts: null
      };
      this.scheduleCopyHelper = new ScheduleCopyHelper();
      if (props.location.state) {
         if (props.location.state.newTaskDay) {
            this.state.newTaskDate = props.location.state.newTaskDay;
            props.location.state.newTaskDay = null;
         }
      }
   }

   componentDidMount = () => this.initializeComponent();

   componentDidUpdate = (prevProps) => {
      const { token } = this.props;
      const isTokenExist = token && token.user && token.user.access_token;

      const tokenChanged = prevProps.token?.user?.access_token !== token?.user?.access_token;
      
      const productCodesChanged = prevProps.session?.kodyProduktow?.length !== this.props.session?.kodyProduktow?.length
      
      if (isTokenExist && (tokenChanged || productCodesChanged)) {
         this.initializeComponent();
      }
   };

   isProductCodesFetched = () => this.props.session?.kodyProduktow.length > 0;

   initializeComponent = () => {
      if (!this.isProductCodesFetched()) return;
      const { session } = this.props;
      const productKeys = (this.props.session.kodyProduktow || []).map((key) => ({
         value: key,
         label: key
      }));

      const selectedProductKey =
         session.selectedProductKey &&
         session.selectedProductKey.value &&
         this.checkIfKeyExists(productKeys, session.selectedProductKey.value)
            ? session.selectedProductKey.value
            : productKeys && productKeys[0]
            ? productKeys[0].value
            : null;

      this.setState(
         {
            productKeys,
            selectedProductKey,
            isFetching: this.props.session.fetching
         },
         () => {
            this.initData();
         }
      );
   };

   handleCopyScheduleWeek = () => {
      const { copyScheduleMode } = this.state;

      if (copyScheduleMode) {
         const payload = this.scheduleCopyHelper.preparePayload(
            this.state.selectedProductKey,
            this.props.schedule.data.dzienWiodacy,
            this.state.users
         );

         this.setState({ isRequesting: true });

         this.scheduleCopyHelper.verifyScheduleCopy(
            payload,
            this.state.users,
            (hasWarnings, warningConflicts) => {
               if (hasWarnings && warningConflicts) {
                  this.setState({
                     warningVisible: true,
                     warningConflicts,
                     isRequesting: false
                  });
                  return;
               }
               this.setState(
                  {
                     copyScheduleMode: false,
                     isRequesting: false
                  },
                  () => {
                     this.initData();
                  }
               );
            }
         );
         return;
      }
      this.setState({ copyScheduleMode: true });
      this.scheduleCopyHelper.reset();
   };

   handleConfirmCopy = () => {
      if (!this.scheduleCopyHelper.verificationData) return;
      this.setState({ isRequesting: true });

      this.scheduleCopyHelper.processCopySchedule(
         this.scheduleCopyHelper.verificationData,
         (success) => {
            if (success) {
               this.setState(
                  {
                     copyScheduleMode: false,
                     warningVisible: false,
                     warningConflicts: null,
                     isRequesting: false
                  },
                  () => {
                     this.initData();
                  }
               );
            } else {
               this.setState({ isRequesting: false });
            }
         }
      );
   };

   handleWarningClose = () => {
      this.setState({
         warningVisible: false,
         warningConflicts: null
      });
   };

   handleTaskSelection = (taskId, userId) => {
      this.scheduleCopyHelper.toggleTaskSelection(taskId, userId);
      this.forceUpdate();
   };

   handleUserSelection = (userId) => {
      this.scheduleCopyHelper.toggleUserSelection(userId);
      this.forceUpdate();
   };

   handleUserTasksSelection = (userId) => {
      const user = this.state.users.find((u) => u.id === userId);
      if (user) {
         this.scheduleCopyHelper.toggleUserTasksSelection(userId, user);
         this.forceUpdate();
      }
   };

   handleSelectAll = () => {
      this.scheduleCopyHelper.toggleSelectAll(this.state.users, this.state.week);
      this.forceUpdate();
   };

   handleDayTasksSelection = (day) => {
      this.scheduleCopyHelper.toggleDayTasksSelection(day, this.state.users);
      this.forceUpdate();
   };

   areDayTasksSelected = (day) => {
      return this.scheduleCopyHelper.areDayTasksSelected(day, this.state.users);
   };

   areAllWeekTasksSelected = () => {
      return this.scheduleCopyHelper.areAllWeekTasksSelected(this.state.users, this.state.week);
   };

   hasAnySelection = () => this.scheduleCopyHelper.hasAnySelection();

   checkIfKeyExists = (productKeys, selectedProductKey) => {
      return productKeys.find((product) => product.value === selectedProductKey);
   };

   initData = () => {
      const { loadSchedule } = this.props;
      if (this.state.newTaskDate == null) {
         const { selectedProductKey, currentDate } = this.state;
         loadSchedule(selectedProductKey, currentDate.format("YYYY-MM-DD")).then(() =>
            this.parseData()
         );
      } else {
         const { selectedProductKey, newTaskDate } = this.state;
         loadSchedule(selectedProductKey, newTaskDate).then(() => this.parseData());
         this.setState({ newTaskDate: null });
      }
   };

   parseData = () => {
      const { data } = this.props.schedule;
      const week = getWeek(data.dzienWiodacy, true);
      const optionalTrips = {};
      data.fakultety.forEach((trip) => {
         trip.counter = 0;
         optionalTrips[trip.data]
            ? optionalTrips[trip.data].push(trip)
            : (optionalTrips[trip.data] = [trip]);
      });
      data.uzytkownicy.forEach((user) => {
         (user.zadania || []).forEach((task) => {
            if (task.typ !== "WycieczkaFakultatywna") return;
            const tripId = task.dane.id;
            if (!optionalTrips[task.data]) return;
            const index = optionalTrips[task.data].findIndex((trip) => trip.id === tripId);
            if (optionalTrips && optionalTrips[task.data] && optionalTrips[task.data][index]) {
               optionalTrips[task.data][index].counter += 1;
            }
         });
      });
      const users = data.uzytkownicy;
      this.setState({ optionalTrips, users, week, scheduleData: data });
   };

   handleDateChange = (date) => {
      this.setState({ currentDate: date }, () => this.initData(date));
   };

   addAnimator = () => {
      const { animatorName, selectedProductKey } = this.state;
      if (animatorName.length < 3)
         return notify.show(this.props.t("toasts.animatorNameTooShort"), "warning", 3000);
      api.createAnimator({ imieNazwisko: animatorName, kodProduktu: selectedProductKey })
         .then(() => {
            this.initData();
            this.setState({ animatorName: "" });
         })
         .catch((err) => console.log(err));
   };

   removeAnimator = (id) => {
      api.deleteAnimator(id)
         .then(() => {
            this.initData();
            this.closeModal();
            notify.show(this.props.t("toasts.scheduleCleared"), "success", 3000);
         })
         .catch((err) => console.log(err));
   };

   removeAnimatorConfirm = (id) => {
      const modalContent = this.renderModal(
         this.props.t("scheduler.confirm.removeUser"),
         () => this.removeAnimator(id),
         this.closeModal
      );
      this.setState({ modalVisibility: true, modalContent });
   };

   manageDropEnd = (dragData) => {
      const { destination, draggableId, source } = dragData;
      const isTask = draggableId.includes("task");
      const isAssignedTrip = draggableId.includes("assigned-trip");
      if (!destination) {
         if (isTask || isAssignedTrip) return this.removeTask(dragData);
         return;
      }
      if (destination.droppableId === source.droppableId) return;
      if (isTask) return this.moveTask(dragData);
      const destinationDate = destination.droppableId.split("_")[1];
      const sourceDate = source.droppableId.split("_")[1];
      if (destinationDate !== sourceDate) return;
      if (isAssignedTrip) return this.moveTask(dragData);
      return this.createTrip(dragData);
   };

   createTrip = (dragData) => {
      const { destination, source } = dragData;
      const { users, selectedProductKey } = this.state;
      const [, date, userId] = destination.droppableId.split("_");
      const assignedUser = users.find((user) => user.id === parseInt(userId, 10));
      const data = {
         dane: { id: source.index },
         data: date,
         kodProduktu: selectedProductKey,
         typ: "WycieczkaFakultatywna",
         uzytkownicy: [
            {
               id: assignedUser.id,
               imieNazwisko: assignedUser.imieNazwisko
            }
         ]
      };
      api.createTask(data)
         .then(() => this.initData())
         .catch((err) => console.log(err));
   };

   moveTask = (dragData) => {
      const { destination, source, draggableId } = dragData;
      const taskId = draggableId.split("_")[1];
      const oldUser = source.droppableId.split("_")[2];
      const [, date, newUser] = destination.droppableId.split("_");
      const data = {
         id: parseInt(taskId, 10),
         nowaData: date,
         nowyUzytkownik: { id: parseInt(newUser, 10) },
         staryUzytkownik: { id: parseInt(oldUser, 10) }
      };
      api.moveTask(data)
         .then(() => this.initData())
         .catch((err) => err);
   };

   removeTask = (dragData) => {
      const { draggableId } = dragData;
      const taskId = draggableId.split("_")[1];
      api.deleteTask(parseInt(taskId, 10)).then(() => this.initData());
   };

   handleKeyChange = (option) => {
      const { currentDate } = this.state;
      this.props.setProductKey(option);
      this.setState({ selectedProductKey: option.value }, () => {
         this.initData(option.value, currentDate);
      });
   };

   clearScheduleWeek = () => {
      const { currentDate, selectedProductKey } = this.state;
      this.setState({ isRequesting: true });
      api.clearScheduleWeek({
         data: currentDate.format(dateFormat),
         kodProduktu: selectedProductKey
      })
         .then(() => {
            this.initData();
            this.closeModal();
            notify.show(this.props.t("toasts.scheduleCleared"), "success", 3000);
         })
         .catch((err) => console.log(err))
         .finally(() => {
            this.setState({ isRequesting: false });
         });
   };

   clearScheduleWeekConfirm = () => {
      const modalContent = this.renderModal(
         this.props.t("scheduler.confirm.clearSchedule"),
         this.clearScheduleWeek,
         this.closeModal
      );
      this.setState({ modalVisibility: true, modalContent });
   };

   closeModal = () => {
      this.setState({ modalVisibility: false, modalContent: "" });
   };

   redirectToTask = (evt, user, day, taskId) => {
      if (this.state.copyScheduleMode) return;
      const { users, selectedProductKey } = this.state;
      evt.preventDefault();
      evt.stopPropagation();
      this.props.history.push({
         pathname: "/tasks-scheduler/new",
         state: {
            user,
            day,
            users,
            selectedProductKey,
            scrollToId: taskId,
            prevPath: this.props.history.location.pathname
         }
      });
   };

   setLeadingDay = (option) => {
      const { selectedProductKey } = this.state;
      const data = { kodProduktu: selectedProductKey, dzienWiodacy: option.value };
      api.setLeadingDay(data).then(() => this.initData());
   };

   handleAddAnimator = (e) => {
      if (e.key === "Enter") {
         this.addAnimator();
      }
   };

   buildTripContainer = () => {
      const { optionalTrips, week } = this.state;
      return week.map((day) => {
         if (!moment(day).isValid()) return false;
         const trips = (optionalTrips[day] || []).map((trip) => (
            <Trip
               data={trip}
               key={trip.id}
               createTrip={this.createTrip}
               count={trip.counter}
               assigned={trip.counter !== 0}
            />
         ));
         const height = 31 * trips.length;
         return (
            <Droppable
               key={`trip-container_${day}`}
               droppableId={`trip-container_${day}`}
               isDropDisabled
            >
               {(provided, snapshot) => (
                  <th ref={provided.innerRef} {...provided.droppableProps} valign="bottom">
                     <div className="position-relative" style={{ height }}>
                        <div className="position-absolute trip-container">{trips}</div>
                        {provided.placeholder}
                     </div>
                  </th>
               )}
            </Droppable>
         );
      });
   };

   renderModal = (text, onConfirm, onClose) => (
      <div>
         <p className="info_message margin--bottom">{text}</p>
         <div className="text-right">
            <button className="btn info__btn" onClick={onConfirm}>
               {this.props.t("common.actions.yes")}
            </button>
            <button className="btn info__btn" onClick={onClose}>
               {this.props.t("common.actions.no")}
            </button>
         </div>
      </div>
   );

   render() {
      const {
         animatorName,
         productKeys,
         selectedProductKey,
         currentDate,
         modalVisibility,
         modalContent,
         isFetching,
         week,
         isRequesting,
         copyScheduleMode,
         warningVisible,
         warningConflicts
      } = this.state;

      const display = isFetching || week.length === 0 ? "display_hidden" : "";
      if (!selectedProductKey && week.length > 0) {
         return (
            <NoDirections
               modalVisibility={modalVisibility}
               modalContent={modalContent}
               closeModal={this.closeModal}
            />
         );
      }
      return (
         <DragDropContext onDragEnd={this.manageDropEnd}>
            <div className="hotels__slide">
               <ModalInfo show={modalVisibility} onHide={this.closeModal}>
                  {modalContent}
               </ModalInfo>
               <TitleComponent className="section_title--width-unset">
                  {this.props.t("scheduler.title")}
               </TitleComponent>
               <Loader show={false} />
               <div className={`flex ${display}`}>
                  <div className="week-arrow">
                     <img
                        src={LeftArrow}
                        className="week-arrow__left"
                        alt="Left arrow"
                        onClick={() =>
                           this.handleDateChange(moment(currentDate).subtract(7, "days"))
                        }
                     />
                  </div>
                  <div className="scheduler__container table-responsive width--100 mt-0 mb-7">
                     <div className="display_inline-block">
                        <table className="scheduler__table">
                           <thead className="trip-thead">
                              <tr>
                                 <th></th>
                                 {this.buildTripContainer()}
                              </tr>
                           </thead>
                           <thead>
                              <tr>
                                 <th>
                                    {copyScheduleMode && (
                                       <div className="flex align-items-center mb-2 w-full pl-2 -mt-1">
                                          <Checkbox
                                             inputId="copyScheduleMode"
                                             className="mr-2"
                                             checked={this.areAllWeekTasksSelected()}
                                             onChange={this.handleSelectAll}
                                          />
                                          <label
                                             htmlFor="copyScheduleMode"
                                             className="cursor-pointer mb-0"
                                          >
                                             {this.props.t("scheduler.selectAll")}
                                          </label>
                                       </div>
                                    )}
                                    <Select
                                       value={productKeys.find(
                                          (key) => key.label === selectedProductKey
                                       )}
                                       options={productKeys}
                                       onChange={this.handleKeyChange}
                                       placeholder={this.props.t("common.selectDestination")}
                                       isClearable={false}
                                       className="xl:px-4 max-w-15rem"
                                       components={{
                                          IndicatorSeparator: () => null
                                       }}
                                       maxMenuHeight={200}
                                    />
                                 </th>
                                 <SchedulerHeader
                                    week={week}
                                    copyMode={copyScheduleMode}
                                    areDayTasksSelected={this.areDayTasksSelected}
                                    handleDayTasksSelection={this.handleDayTasksSelection}
                                    setLeadingDay={this.setLeadingDay}
                                 />
                              </tr>
                           </thead>
                           <tbody>
                              <SchedulerRows
                                 users={this.state.users}
                                 selectedProductKey={this.state.selectedProductKey}
                                 week={this.state.week}
                                 copyScheduleMode={this.state.copyScheduleMode}
                                 scheduleCopyHelper={this.scheduleCopyHelper}
                                 removeAnimatorConfirm={this.removeAnimatorConfirm}
                                 handleTaskSelection={this.handleTaskSelection}
                                 redirectToTask={this.redirectToTask}
                                 moveTask={this.moveTask}
                                 removeTask={this.removeTask}
                                 handleUserTasksSelection={this.handleUserTasksSelection}
                                 history={this.props.history}
                              />
                              <tr>
                                 <td>
                                    <div className="flex add-animator">
                                       <input
                                          value={animatorName}
                                          onKeyDown={this.handleAddAnimator}
                                          onChange={(e) =>
                                             this.setState({ animatorName: e.target.value })
                                          }
                                          placeholder={this.props.t("scheduler.animatorNamePlaceholder")}
                                       ></input>
                                       <button onClick={this.addAnimator}>{this.props.t("common.actions.ok")}</button>
                                    </div>
                                 </td>
                                 <td colSpan="7"></td>
                              </tr>
                           </tbody>
                        </table>
                     </div>
                  </div>
                  <div className="week-arrow">
                     <img
                        src={RightArrow}
                        className="week-arrow__right"
                        alt="Right arrow"
                        onClick={() => this.handleDateChange(moment(currentDate).add(7, "days"))}
                     />
                  </div>
               </div>

               <SchedulerButtons
                  onClearSchedule={this.clearScheduleWeekConfirm}
                  onCopySchedule={this.handleCopyScheduleWeek}
                  onCancelCopy={() => {
                     this.setState({ copyScheduleMode: false });
                     this.scheduleCopyHelper.reset();
                  }}
                  copyMode={copyScheduleMode}
                  isRequesting={isRequesting}
                  canCopy={!copyScheduleMode || this.hasAnySelection()}
               />

               <WarningDialog
                  header={this.props.t("copySchedule.overwriteHeader")}
                  message={
                     warningConflicts
                        ? formatConflictMessage(warningConflicts.conflicts, warningConflicts.users)
                        : ""
                  }
                  visible={warningVisible}
                  onHide={this.handleWarningClose}
                  onConfirm={this.handleConfirmCopy}
                  loading={isRequesting}
               />
            </div>
         </DragDropContext>
      );
   }
}

// withTranslation must stay OUTSIDE connect: connect is memoized, so it would otherwise bail
// out on a language change and never re-render with the new translations.
export default withTranslation(
   connect(
      (state) => ({
         session: state.session,
         schedule: state.schedule,
         token: state.oidc
      }),
      { loadSchedule, setProductKey }
   )(TasksScheduler)
);
